import { render, staticRenderFns } from "./PurchaserField.vue?vue&type=template&id=635bb588"
import script from "./PurchaserField.vue?vue&type=script&lang=js"
export * from "./PurchaserField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports